import React, { useEffect, useState } from "react";
import Main from "../../../../layout/main/Main";
import { Link, useSearchParams } from "react-router-dom";
import { Select } from "antd";
import {
	openNotificationWithIcon,
	TYPE,
} from "../../../../../utils/notificationToast";
import {
	export_products,
	import_photos,
	import_products,
} from "../../../../../api/endpoints/import";
import {
	AntdButton,
	ButtonContainer,
	ImportHistoryContainer,
	UploadFile,
} from "./styles";
import moment from "moment";
import { get_clients_simplified } from "../../../../../api/endpoints/clients";
import { BsUpload, BsDownload } from "react-icons/bs";
import ImportHistory from "../history/list/ImportHistory";

export default function Import() {
	const [searchParams] = useSearchParams();
	const uri = searchParams.get("uri");
	const [errors, setErrors] = useState(null);
	const [clients, setClients] = useState(null);
	const [selectedClient, setSelectedClient] = useState(null);
	const [buttonsState, setButtonsState] = useState(true);
	const [isLoading, setIsLoading] = useState([false, false, false]);

	const selectLaboratory = async (e) => {
		setSelectedClient(e);
		setButtonsState(true);
	};

	const fetch_clients = async () => {
		const res = await get_clients_simplified();
		setClients(
			res
				.filter((i) => i.isSeller === true && i.isOneMarket === false)
				.map((r) => ({
					value: r.id,
					label: r.name,
					isApproved: r.isApproved,
				}))
		);
	};
	useEffect(() => {
		fetch_clients();
	}, []);

	const handleChange = async (e, type) => {
		if (!selectedClient && (type === "products" || type === "images")) {
			openNotificationWithIcon(
				TYPE.ERROR,
				"No hay cliente seleccionado",
				"Falta elegir un cliente para que pueda importar productos o imagenes"
			);
		}
		if (selectedClient && type === "products") {
			setIsLoading([false, true, false]);
			try {
				const formData = new FormData();
				formData.append(
					"file",
					e.fileList[e.fileList.length - 1].originFileObj
				);
				formData.append(
					"data",
					JSON.stringify({
						clientId: selectedClient,
					})
				);
				const res = await import_products(formData);
				setErrors(res);
				if (res.length === 0) {
					openNotificationWithIcon(
						TYPE.SUCCESS,
						"Los productos se crearon con exito",
						"Los productos se crearon con exito"
					);
				}
				if (res.length > 0) {
					openNotificationWithIcon(
						TYPE.ERROR,
						"Los productos que intenta subir no se cargaron",
						"Los productos que intenta subir tienen problemas, reviselos y subalos de nuevo"
					);
				}
			} catch (err) {
				openNotificationWithIcon(
					TYPE.ERROR,
					"Error de archivo",
					"Los productos deben subirse en formato excel o verifique que este bien su excel"
				);
			} finally {
				setIsLoading([false, false, false]);
			}
		}

		if (type === "export") {
			setIsLoading([true, false, false]);

			try {
				const res = await export_products(selectedClient);
				const href = URL.createObjectURL(res);

				const link = document.createElement("a");
				link.href = href;

				const fileName = moment().format("DD-MM-YYYY") + ".xlsx";
				link.setAttribute("download", fileName);
				document.body.appendChild(link);
				link.click();

				document.body.removeChild(link);
				URL.revokeObjectURL(href);
			} catch (err) {
				console.log(err);
			} finally {
				setIsLoading([false, false, false]);
			}
		}
		if (selectedClient && type === "images") {
			setIsLoading([false, false, true]);

			try {
				const formData = new FormData();
				formData.append("data", JSON.stringify({ clientId: selectedClient }));
				formData.append(
					"file",
					e.fileList[e.fileList.length - 1].originFileObj
				);
				const res = await import_photos(formData);
				openNotificationWithIcon(
					TYPE.SUCCESS,
					"Las imagenes se subieron con exito",
					"Las imagenes se subieron con exito"
				);
			} catch (err) {
				openNotificationWithIcon(
					TYPE.ERROR,
					"Las imagenes no se cargaron",
					"Las imagenes tienen problemas, reviselas y subalas de nuevo"
				);
			} finally {
				setIsLoading([false, false, false]);
			}
		}
	};

	return (
		<Main>
			<Main.Header>
				<Main.Breadcrumb>
					<Main.BreadcrumbItem>
						{uri ? (
							<Link to={"/" + uri}>Configuración General</Link>
						) : (
							<Link to="/">Home</Link>
						)}
					</Main.BreadcrumbItem>
					<Main.BreadcrumbSeparator />
					<Main.ActiveBreadcrumbItem>
						{uri ? "Importadores" : "Importar"}
					</Main.ActiveBreadcrumbItem>
				</Main.Breadcrumb>
			</Main.Header>
			<Main.Body>
				<Select
					showSearch
					placeholder="Elegi un cliente"
					optionFilterProp="children"
					onChange={(e) => selectLaboratory(e)}
					filterOption={(input, option) =>
						(option?.label ?? "").toLowerCase().includes(input.toLowerCase())
					}
					options={clients}
					style={{ width: 180 }}
				/>
				<ButtonContainer>
					{buttonsState && (
						<>
							<AntdButton
								onClick={(e) => handleChange(e, "export")}
								loading={isLoading[0]}
							>
								<BsDownload
									style={{ position: "relative", top: "0.8px", left: "-5px" }}
								/>{" "}
								Descargar productos
							</AntdButton>
							<AntdButton
								loading={isLoading[1]}
								style={{
									display: "flex",
									justifyContent: "center",
									alignItems: "center",
									width: "170px",
								}}
							>
								<UploadFile
									multiple={false}
									showUploadList={false}
									beforeUpload={() => false}
									action={null}
									onChange={(e) => handleChange(e, "products")}
								>
									<BsUpload
										style={{ position: "relative", top: "0.8px", left: "-5px" }}
									/>
									Subir productos
								</UploadFile>
							</AntdButton>
							<AntdButton
								loading={isLoading[2]}
								style={{
									display: "flex",
									justifyContent: "center",
									alignItems: "center",
									width: "170px",
								}}
							>
								{" "}
								<UploadFile
									multiple={false}
									showUploadList={false}
									beforeUpload={() => false}
									action={null}
									onChange={(e) => handleChange(e, "images")}
								>
									<BsUpload
										style={{ position: "relative", top: "0.8px", left: "-5px" }}
									/>
									Subir imagenes
								</UploadFile>
							</AntdButton>
						</>
					)}
				</ButtonContainer>

				<ImportHistoryContainer>
					<ImportHistory isLoading={isLoading} />
				</ImportHistoryContainer>
			</Main.Body>
		</Main>
	);
}
